import type { GQL_ID } from '@@partner:types:graphql'
import type { MenuItem, LinkType, MenuItemTranslation } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

export interface CreateMenuItemInput {
  menu_id: GQL_ID
  internal_name: string
  title: string
  image_file_id?: GQL_ID | null
  icon_code?: string
  icon_color?: string
  text_color?: string
  link_url?: string
  link_type: LinkType
  bold: boolean
  is_active?: boolean
  sort_order?: number
  i18n?: MenuItemTranslation[]
}

export interface CreateMenuItemMutation {
  createMenuItem: MenuItem
}

export interface CreateMenuItemVariables {
  input: CreateMenuItemInput
}

export const GQL_MUTATION_CREATE_MENU_ITEM = gql`
  mutation createMenuItem($input: CreateMenuItemInput!) {
    createMenuItem(input: $input) {
      id
      menu_id
      internal_name
      title
      image_file_id
      icon_code
      icon_color
      text_color
      link_url
      link_type
      bold
      is_active
      sort_order
      created_at
      updated_at
      
      image {
        url
      }
      
      translations {
        language_code
        title
      }
      
      i18n {
        language_code
        title
      }
    }
  }
`

export const useCreateMenuItem = () =>
  useMutation<CreateMenuItemMutation, CreateMenuItemVariables>(GQL_MUTATION_CREATE_MENU_ITEM)
